import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { CreateEditPaymentTypeComponent } from '@app/core/windows'; 


@Component({
  selector: 'payments-types-crud',
  templateUrl: './payments-types-crud.component.html',
  providers: [ DatasourceService ]
})
export class PaymentsTypesCrudComponent extends BaseCrudComponent implements OnInit {

  //Window
  @ViewChild(CreateEditPaymentTypeComponent, {static: false}) window !: CreateEditPaymentTypeComponent;

  protected menu: string = 'Conceptos';

  protected menuIcon: string = 'gears';
  
  protected label: string = 'Tipo de Pago';

  protected name: string = 'Tipos de Pagos';

  protected table: string = 'payments_types';
  
  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {
    
    super(authService, service, alertService);
    console.log(this.constructor.name);
    this.breadcrumbItems = this.getBreadcumItems();

  }  

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [      
      {field: 'name', dir: 'asc'}
    ];

    return s;

  }

  ngOnInit() { 
    
    super.ngOnInit();    
  
  }

}